// extracted by mini-css-extract-plugin
export var dividerLine = "_7q-3";
export var itemImage = "_7q-9";
export var lightDivider = "_7q-4";
export var modalContent = "_7q-5";
export var modalContentCompact = "_7q-6";
export var productCard = "_7q-a";
export var productImage = "_7q-b";
export var productImageCompact = "_7q-7";
export var productImagePlaceholder = "_7q-c";
export var productImagePlaceholderCompact = "_7q-8";
export var progressBarBackground = "_7q-1";
export var progressBarContainer = "_7q-0";
export var progressBarFill = "_7q-2";